import React from 'react';
import './App.scss';
import MainPage from './pages/MainPage';

function App() {
  return (
    <div data-component="App">
      <MainPage />
    </div>
  );
}

export default App;
